module.exports = __webpack_public_path__ + "img/default-student.376cf8fc.png";